// The call's cues, made with an oscillator (no sound files): joining is two
// rising notes, someone coming one soft note, someone going one falling note.
// Each note rises and fades so it does not click.
import type { CallAudio } from "./audio";

export type VoiceCue = "joined" | "peer_joined" | "peer_left";
export type PlayVoiceCue = (cue: VoiceCue) => void;

interface Note {
  /** Seconds before it starts. */
  at: number;
  from: number;
  to: number;
  len: number;
}

const CUES: Record<VoiceCue, Note[]> = {
  joined: [
    { at: 0, from: 523, to: 523, len: 0.14 },
    { at: 0.12, from: 784, to: 784, len: 0.2 },
  ],
  peer_joined: [{ at: 0, from: 659, to: 659, len: 0.18 }],
  peer_left: [{ at: 0, from: 600, to: 400, len: 0.22 }],
};

const PEAK = 0.12;

export function cuePlayer(audio: CallAudio): PlayVoiceCue {
  return (cue) => {
    const ac = audio.ensure();
    if (!ac) return;
    const t0 = ac.currentTime;
    for (const n of CUES[cue]) {
      const osc = ac.createOscillator();
      const gain = ac.createGain();
      osc.type = "sine";
      const start = t0 + n.at;
      const end = start + n.len;
      osc.frequency.setValueAtTime(n.from, start);
      if (n.to !== n.from)
        osc.frequency.exponentialRampToValueAtTime(n.to, end);
      gain.gain.setValueAtTime(0.0001, start);
      gain.gain.exponentialRampToValueAtTime(PEAK, start + 0.015);
      gain.gain.exponentialRampToValueAtTime(0.0001, end);
      osc.connect(gain).connect(ac.destination);
      osc.start(start);
      osc.stop(end + 0.02);
      osc.onended = () => {
        osc.disconnect();
        gain.disconnect();
      };
    }
  };
}
